import { Button, ButtonWithPopup, Text, Tooltip } from '@innovationdepartment/proxima-ui';
import { ReplayOutlined } from '@mui/icons-material';
import { useState } from 'react';
import { ConfirmActions, ConfirmContent, RetryButton } from './BrandWorkflows.styles';

type RetryFromFailedButtonProps = {
  workflowType: string;
  disabled?: boolean;
  onConfirm: () => void;
};

/* Confirm-and-retry action for a failed run */
const RetryFromFailedButton = ({
  workflowType,
  disabled,
  onConfirm
}: RetryFromFailedButtonProps) => {
  const [open, setOpen] = useState(false);

  const onConfirmClick = () => {
    setOpen(false);
    onConfirm();
  };

  return (
    <ButtonWithPopup
      open={open}
      onOpen={() => {
        if (!disabled) setOpen(true);
      }}
      onClose={() => setOpen(false)}
      placement="bottom-left"
      buttonElement={
        /* The span keeps the tooltip alive while the button is disabled — a disabled
           button swallows the pointer events the tooltip listens for */
        <Tooltip title="Retry from failed task">
          <span>
            <RetryButton
              type="button"
              disabled={disabled}
              onClick={() => {}}
              aria-label={`Retry ${workflowType} from failed task`}
            >
              <ReplayOutlined />
            </RetryButton>
          </span>
        </Tooltip>
      }
    >
      <ConfirmContent>
        <Text variant="body2">
          Retry this workflow from its failed task? The run will restart where it left off.
        </Text>
        <ConfirmActions>
          <Button label="Cancel" variant="text" size="small" onClick={() => setOpen(false)} />
          <Button label="Retry" color="error" size="small" onClick={onConfirmClick} />
        </ConfirmActions>
      </ConfirmContent>
    </ButtonWithPopup>
  );
};

export default RetryFromFailedButton;
